import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { fetchPortfolio } from '../services';

// Thunk asíncrono para obtener los datos de family desde la API
export const fetchPortfolioData = createAsyncThunk(
    'family/fetchPortfolioData',
    async (_, { rejectWithValue }) => {
        try {
            const data = await fetchPortfolio(); // Llama al servicio de la API
            return data;
        } catch (error) {
            return rejectWithValue(error.message); // Manejo de errores
        }
    }
);

const portfolioSlice = createSlice({
    name: 'porfolio',
    initialState: {
        data: [],
        loading: false,
        error: null,
    },
    reducers: {
        // Puedes agregar más acciones sincronas si es necesario
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchPortfolioData.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchPortfolioData.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload;
            })
            .addCase(fetchPortfolioData.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    },
});

export default portfolioSlice.reducer;
